import { render, staticRenderFns } from "./OpenOrdersAggregated.vue?vue&type=template&id=3f83c128"
import script from "./OpenOrdersAggregated.vue?vue&type=script&lang=js"
export * from "./OpenOrdersAggregated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports